import axios from "axios";

async function getClientActiveConsentsApi(uuid: string, clientUuid: string) {
    return axios({
        method: 'GET',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/consents`
    });
}
async function postClientActiveConsentsApi(uuid: string, clientUuid: string, data: string) {
    return axios({
        method: 'POST',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/consents`,
        data: {
            consentId: data
        }
    });
}

async function deleteClientActiveConsentsApi(uuid: string, clientUuid: string, consentUuid: string) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/consents/${consentUuid}`,
    });
}

async function getAllClientConsentsStoryApi(uuid: string, clientUuid: string) {
    return axios({
        method: 'GET',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/consents-story`,
    });
}



export {
    getClientActiveConsentsApi,
    postClientActiveConsentsApi,
    deleteClientActiveConsentsApi,
    getAllClientConsentsStoryApi,

}
